<template>
  <div>
    <!-- Top Bar Navigation -->
    <div class="d-flex align-items-center w-full gap-[.75rem] mb-[2rem]">
      <BButton
        id="filter"
        size="sm"
        variant="primary"
        class="!p-[.6rem]"
        @click="$router.push('/churn-request')"
      >
        <span
          class="k-arrow-left-2 text-[16px]"
        />
      </BButton>
      <h5 class="text-[#333333] text-2xl font-semibold mb-0">
        Detail Request
      </h5>
    </div>

    <!-- Sub Header Section -->
    <div class="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
      <div>
        <h1 class="text-xl font-semibold text-black mb-[.5rem]">
          Detail Churn Request
        </h1>
        <div class="flex items-center gap-[.5rem]">
          <span class="text-sm text-[#737373] font-medium">{{ data.id }}</span>
          <span
            v-if="statusName"
            class="inline-flex items-center gap-1.5 px-[.75rem] py-[.25rem] rounded-full text-sm"
            :class="statusBadgeClass"
          >
            <span
              class="w-1.5 h-1.5 rounded-full"
              :class="statusDotClass"
            />
            {{ statusName }}
          </span>
        </div>
      </div>
      <div>
        <BButton
          v-if="isCancelable"
          variant="outline-primary"
          :disabled="isLoadingCancel"
          @click="handleCancelRequest"
        >
          <BSpinner
            v-if="isLoadingCancel"
            small
            class="me-1"
          />
          Batalkan Request
        </BButton>
      </div>
    </div>
  </div>
</template>

<script>
import { komtimAxiosIns } from '@/libs/axios'
import { showSuccess, showError } from '../../config'

export default {
  name: 'DetailHeader',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isLoadingCancel: false,
    }
  },
  computed: {
    isCancelable() {
      return !this.data.invoice.detail && !['CANCELLED', 'COMPLETED'].includes(this.data.status.code)
    },
    statusName() {
      if (this.data.status.code === 'IN_PROGRESS' && this.data.invoice_status === 'UNPAID') return 'Menunggu Pembayaran'
      return this.data && this.data.status ? this.data.status.name : ''
    },
    statusCode() {
      if (this.data.status.code === 'IN_PROGRESS' && this.data.invoice_status === 'UNPAID') return 'WAITING_PAYMENT'
      return this.data && this.data.status ? this.data.status.code : ''
    },
    statusBadgeClass() {
      const code = (this.statusCode || '').toUpperCase()
      if (['IN_PROGRESS', 'SUBMITTED'].includes(code)) {
        return 'bg-[#FFF7C2] text-[#AB6400]'
      }
      if (code === 'COMPLETED') {
        return 'bg-[#D6F1DF] text-[#30A46C]'
      }
      if (code === 'WAITING_PAYMENT' || code === 'CANCELLED') {
        return 'bg-[#FDE8E8] text-[#E53E3E]'
      }
      return 'bg-[#F5F5F5] text-[#737373]'
    },
    statusDotClass() {
      const code = (this.statusCode || '').toUpperCase()
      if (['IN_PROGRESS', 'SUBMITTED'].includes(code)) {
        return 'bg-[#FFC53D]'
      }
      if (code === 'COMPLETED') {
        return 'bg-[#30A46C]'
      }
      if (code === 'WAITING_PAYMENT' || code === 'CANCELLED') {
        return 'bg-[#E53E3E]'
      }
      return 'bg-[#737373]'
    },
  },
  methods: {
    async handleCancelRequest() {
      if (!this.data || !this.data.id) return

      try {
        this.isLoadingCancel = true
        const url = `/v1/partner_assignment_requests/${this.data.id}/cancel`
        await komtimAxiosIns.put(url, {
          reason: '',
        })
        showSuccess({ title: 'Berhasil Batalkan Request!' })
        this.$emit('cancelled')
      } catch {
        showError({ title: 'Gagal Batalkan Request!' })
      } finally {
        this.isLoadingCancel = false
      }
    },
  },
}
</script>
